import MainNavLayout from '@/components/layout/MainNavLayout'
import { FILE_TYPE, COVERT_TARGET_TYPE, CUSTOM_OPTION_TYPE, CMD } from '@/config/config'

export default [
  {
    path: '/jpg2pdf',
    component: MainNavLayout,
    children: [
      {
        path: '',
        name: 'Jpg2pdf',
        meta: {
          groupDefault: {
            cmd: CMD.IMG_TO_PDF,
            fileType: FILE_TYPE.IMG,
            toFileType: FILE_TYPE.PDF,
            targetTypes: [COVERT_TARGET_TYPE.PDF],
            customOptionType: CUSTOM_OPTION_TYPE.IMG_TO_PDF
          }
        },
        component: () => import('@/views/Convert')
      }
    ]
  },
  {
    path: '/pdf2png',
    component: MainNavLayout,
    children: [
      {
        path: '',
        name: 'Pdf2png',
        meta: {
          groupDefault: {
            cmd: CMD.PDF_TO_IMG,
            fileType: FILE_TYPE.PDF,
            toFileType: FILE_TYPE.PNG,
            targetTypes: [COVERT_TARGET_TYPE.PNG, COVERT_TARGET_TYPE.JPG, COVERT_TARGET_TYPE.BMP]
          }
        },
        component: () => import('@/views/Convert')
      }
    ]
  },
  {
    path: '/pdf2bmp',
    component: MainNavLayout,
    children: [
      {
        path: '',
        name: 'Pdf2bmp',
        meta: {
          groupDefault: {
            cmd: CMD.PDF_TO_IMG,
            fileType: FILE_TYPE.PDF,
            toFileType: FILE_TYPE.BMP,
            targetTypes: [COVERT_TARGET_TYPE.BMP, COVERT_TARGET_TYPE.JPG, COVERT_TARGET_TYPE.PNG]
          }
        },
        component: () => import('@/views/Convert')
      }
    ]
  }
]
